import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import Text from '../Text/Text';
import './Tools.css';
import COS_TOOLS_1 from '../../images/COS_TOOLS_1.jpg';
import COS_TOOLS_2 from '../../images/COS_TOOLS_2.jpg';
import COS_TOOLS_3 from '../../images/COS_TOOLS_3.jpg';
import COS_LOGO_ROUND from '../../images/COS_LOGO_ROUND.png';

const Tools = () => {
  return (
    <div className="Tools">
      <SectionTitle classname="Tools__title">
        Notre<strong className="SectionTitle__item--bold">&nbsp;réseau</strong>
      </SectionTitle>
      <SectionTitle classname="Tools__title" greenLight={true}>
        Des outils efficaces à votre disposition
      </SectionTitle>
      <div className="Tools__tool">
        <img
          src={COS_LOGO_ROUND}
          className="Tools__logo"
          alt="smile"
          loading="lazy"
        />
        <img className="Tools__tool__image" src={COS_TOOLS_1} alt="" />
        <div className="Tools__tool__infos">
          <Text classname="Tools__tool__title" bold={true}>
            Aide au pilotage de votre pharmacie
          </Text>
          <Text classname="Tools__tool__text">
            Des outils et des services pour vous faciliter votre quotidien
          </Text>
        </div>
      </div>
      <div className="Tools__tool">
        <div className="Tools__tool__infos">
          <Text classname="Tools__tool__title" bold={true}>
            Des conditions commerciales pour des produits au juste prix
          </Text>
        </div>
        <img className="Tools__tool__image" src={COS_TOOLS_2} alt="" />
      </div>
      <div className="Tools__tool">
        <img className="Tools__tool__image" src={COS_TOOLS_3} alt="" />
        <div className="Tools__tool__infos">
          <Text classname="Tools__tool__title" bold={true}>
            Des outils de suivi patient
          </Text>
          <Text classname="Tools__tool__text">
            Pour une meilleure prise en charge de vos patients (Scan
            d'ordonnance, prise de rdv...)
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Tools;
